import { createAction } from '@wix/communities-blog-client-common';

export const actionsClosed = createAction('moreButton/ACTIONS_CLOSED');
